<div class="flex w-[calc(100%-64px)] flex-col gap-4">
  <aura-password-checker
    [maxlength]="30"
    [label]="'Nouveau mot de passe'"
    [control]="passwordControl"
    [readonly]="false"
    [showPasswordStrength]="true"
  />
  <aura-password-checker
    [maxlength]="30"
    [label]="'Confirmer le mot de passe'"
    [control]="passwordConfirmControl"
    [readonly]="false"
    [showPasswordStrength]="false"
    [id]="'confirmPassword'"
  />
</div>
